import ButtonController from "../../../components/containers/buttonController";
import DownloadButton from "../../../components/common/button/DownloadButton";
import Pagination from "../../../components/common/pagination/Pagination";
import { reportConfig } from "../../../utils/config/tableReportConfig.js";
import useClearFilters from "../../../hooks/filter/useClearFilters";
import DynamicTable from "../../../components/tables/dynamicTable";
import { getFilteredReport } from "../../../utils/api/reportData";
import { getDynamicSelectData } from "../../../utils/api/data";
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import React, { useEffect, useState } from "react";
import { config } from "../../../config/Constants";
import "../remitIngestion/RemitIngestion.css";
import { useSelector,  } from "react-redux";
import Cookies from "js-cookie";
import Axios from 'axios';


const RemitIngestion = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadData, setDownloadData] = useState([]);
  const [rowsDisplayed, setRowsDisplayed] = useState(0);
  const [filteredReportData, setFilteredReportData] = useState([]);
  const [totalPages, setTotalPages] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const reportFilters = useSelector((state) => state.report.reportFilter);
  const pageSize = 250;
  const company = Cookies.get("cp-cn")
  
  useClearFilters();

  //initial data fetch if no filters are selected
  useEffect(() => {
    const hasActiveFilters = reportFilters.some((filter) =>filter.field !== "" && filter.operator !== "" && filter.value !== "");
    if (hasActiveFilters) {
      filterReport();
    } 
    else {
      getRemitData(); 
      setTotalPages(100);
    }
  }, [reportFilters, rowsDisplayed]);

  //get filtered data with selected filters
  const filterReport = async () => {
    setLoading(true);
    const filteredData = await getFilteredReport( "remitingestion", Cookies.get("cp-cn"), reportFilters );
    setFilteredReportData(filteredData);
    setReportData(filteredData);
    setDownloadData(filteredData);
    setTotalPages(Math.ceil(filteredData.length / pageSize));
    setCurrentPage(1);
    setLoading(false);
  };

  //full data call for download button
  const getRemitData = async () => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      setLoading(true);
      const baseQuery = {
        selectValues: reportConfig["remitIngestion"].selectValues,
        tableName: "REPORT.LTL_REMIT_INGESTION_VW",
        whereField: ["REPORT_CLIENTNAME"],
        whereOperators: ["="],
        whereValue: [company.toUpperCase()],
        orderBy: "BOL",
        db: "SF"
      };
      //recall the basequery as a promise for the paginated results
      const [paginated, full] = await Promise.all([
        getDynamicSelectData({ ...baseQuery, offset: { rowsDisplayed, pageSize } }),
        getDynamicSelectData(baseQuery)
      ]);
      //set pagianted results and full results for download
      setReportData(paginated);
      setDownloadData(full);
      setLoading(false);
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      setLoading(true);
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: 'remitingestion',
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData(response.data.report)
      setLoading(false);
    };
  };

  //handle page change
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setRowsDisplayed((newPage - 1) * pageSize);
  };
  
  return (
    <div className="remitIngestionPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="remitIngestionPageContent">
          <div className="remitIngestionTop">
            <div className="remitIngestionTitle">
              <h1>Freight Remit Data</h1>
            </div>
          </div>
          <div className="remitIngestionem">
              <em >Downloading the Report will provide a file with <strong>all</strong> data if un-filtered.</em>
              <em>Downloading the Report after filtering will provide a file with <strong>all</strong> data from the filtered set only.</em>
            </div>
          <div className="remitIngestionMid">
            <div className="remitIngestionReportSpace">
              <div className="remitIngestionReport">
                {loading ? (
                  <CircularProgress style={{ margin: 'auto', display: 'block' }} />
                ) : (
                  <DynamicTable dataObject={{ data: reportData, size: "small" }} />
                )}
              </div>
              <div className="reportButtons">
                <div>
                  <DownloadButton data={downloadData} fileName={"freight_remit_data"}/>
                </div>
                <div className="remitIngestionPaginationContainer">
                  <Pagination totalPages={totalPages} onPageChange={handlePageChange} boundaryCount={2}/>
                </div>
                <div>
                  <ButtonController reportName={'Remit Ingestion'} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemitIngestion;
